import React from "react";

function LostCustomer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#b7d341"
        d="M511.996 256c0 141.383-114.613 255.996-255.996 255.996C114.613 511.996 0 397.383 0 256S114.613 0 256 0c141.383 0 255.996 114.617 255.996 256zm0 0"
        data-original="#854f89"
      ></path>
      <path
        fill="#bfd5de"
        d="M382.117 449.574v29.246C344.898 499.938 301.86 511.996 256 511.996c-27.031 0-53.07-4.187-77.531-11.953a254.164 254.164 0 01-48.59-21.223v-29.246c0-49.914 38.441-90.863 87.355-94.812a95 95 0 017.782-.313h61.953c7.324 0 14.449.813 21.297 2.383 42.296 9.676 73.851 47.531 73.851 92.742zm0 0"
        data-original="#bfd5de"
      ></path>
      <path
        fill="#dde8ed"
        d="M382.121 449.574v29.246a253.994 253.994 0 01-102.547 32.09A254.379 254.379 0 01256 511.996c-7.95 0-15.816-.363-23.582-1.074a255.09 255.09 0 01-53.95-10.879v-50.469c0-52.535 42.602-95.125 95.15-95.125h13.355c52.558 0 95.148 42.59 95.148 95.125zm0 0"
        data-original="#dde8ed"
      ></path>
      <path
        fill="#d3a489"
        d="M162.887 249.531c0 15.715-11.477 28.742-26.508 31.16a31.687 31.687 0 01-5.059.407c-17.433 0-31.562-14.13-31.562-31.567s14.129-31.562 31.562-31.562c1.727 0 3.414.136 5.059.402 15.031 2.418 26.508 15.45 26.508 31.16zm0 0"
        data-original="#d3a489"
      ></path>
      <path
        fill="#f74f4f"
        d="M281.535 388.773L256 429.734l-25.54-40.96"
        data-original="#f74f4f"
      ></path>
      <path
        fill="#f74f4f"
        d="M279.574 510.91A254.379 254.379 0 01256 511.996c-7.95 0-15.816-.363-23.582-1.074L256 419.074zm0 0"
        data-original="#f74f4f"
      ></path>
      <path
        fill="#bf8e75"
        d="M162.887 249.531c0 15.715-11.477 28.742-26.508 31.16a117.333 117.333 0 01-4.191-31.16c0-10.781 1.46-21.23 4.19-31.16 15.032 2.418 26.509 15.45 26.509 31.16zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#bf8e75"
        d="M142.605 249.531c0 6.23-5.054 11.281-11.285 11.281-6.23 0-11.28-5.05-11.28-11.28s5.05-11.282 11.28-11.282c6.23 0 11.285 5.05 11.285 11.281zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#bfd5de"
        d="M255.992 393.39l-42.832 23.805-13.027-60.605 26.613-15.672m29.246 52.472l42.828 23.805 13.028-60.605-26.61-15.672"
        data-original="#bfd5de"
      ></path>
      <path
        fill="#d3a489"
        d="M349.102 249.531c0 15.715 11.48 28.742 26.511 31.16a31.59 31.59 0 005.055.407c17.437 0 31.566-14.13 31.566-31.567s-14.129-31.562-31.566-31.562a31.64 31.64 0 00-5.055.402c-15.031 2.418-26.511 15.45-26.511 31.16zm0 0"
        data-original="#d3a489"
      ></path>
      <g fill="#bf8e75">
        <path
          d="M349.102 249.531c0 15.715 11.48 28.742 26.511 31.16a117.49 117.49 0 004.188-31.16c0-10.781-1.457-21.23-4.188-31.16-15.031 2.418-26.511 15.45-26.511 31.16zm0 0"
          data-original="#bf8e75"
        ></path>
        <path
          d="M391.95 249.531c0 6.23-5.052 11.281-11.282 11.281s-11.281-5.05-11.281-11.28 5.05-11.282 11.281-11.282 11.281 5.05 11.281 11.281zm0 0"
          data-original="#bf8e75"
        ></path>
        <path
          d="M373.438 232.754c0 58.445-42.696 106.926-98.594 115.926a116.144 116.144 0 01-18.848 1.52c-64.867 0-117.441-52.579-117.441-117.446 0-30.688 14.582-76.762 33.855-97.684 21.461-23.297 49.41-19.758 83.586-19.758 6.422 0 12.715.508 18.848 1.516 55.898 9 98.594 57.484 98.594 115.926zm0 0"
          data-original="#bf8e75"
        ></path>
        <path
          d="M289.941 317.8v41.653c0 15.25-10.058 28.14-23.906 32.422a33.86 33.86 0 01-10.043 1.516c-18.746 0-33.937-15.192-33.937-33.938v-41.652zm0 0"
          data-original="#bf8e75"
        ></path>
      </g>
      <path
        fill="#d3a489"
        d="M289.941 356.816v2.641c0 15.25-10.058 28.137-23.906 32.418-12.496-3.84-21.89-14.703-23.629-28 2.27.14 4.547.207 6.84.207 6.422 0 12.715-.508 18.848-1.516a115.483 115.483 0 0021.847-5.75zm83.497-124.062c0 58.445-42.696 106.926-98.594 115.926-55.899-9-98.594-57.48-98.594-115.926 0-35.984 16.188-68.195 41.691-89.742 15.899-13.446 35.43-22.727 56.903-26.184 52.117 8.387 92.765 51.106 98.015 104.215.383 3.855.579 7.766.579 11.71zm0 0"
        data-original="#d3a489"
      ></path>
      <path
        fill="#bf8e75"
        d="M255.996 278.625c9.836 0 19.668 2.465 28.633 7.395a5.227 5.227 0 012.062 7.093 5.232 5.232 0 01-7.097 2.063c-14.774-8.125-32.418-8.125-47.196 0a5.224 5.224 0 01-5.03-9.156c8.96-4.93 18.796-7.395 28.628-7.395zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#3d4159"
        d="M230.984 225.922c0 7.355-5.964 13.32-13.32 13.32-7.36 0-13.324-5.965-13.324-13.32 0-7.36 5.965-13.324 13.324-13.324 7.356 0 13.32 5.964 13.32 13.324zm76.668 0c0 7.355-5.964 13.32-13.32 13.32-7.36 0-13.324-5.965-13.324-13.32 0-7.36 5.965-13.324 13.324-13.324 7.356 0 13.32 5.964 13.32 13.324zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#fff"
        d="M228.27 223.57a5.71 5.71 0 11-5.711-5.71 5.713 5.713 0 015.71 5.71zm77.32 0a5.71 5.71 0 01-11.418 0 5.713 5.713 0 015.71-5.71 5.71 5.71 0 015.708 5.71zm0 0"
        data-original="#ffffff"
      ></path>
      <path
        fill="#bf8e75"
        d="M269.32 259.465h-26.644a5.749 5.749 0 110-11.496h26.644a5.748 5.748 0 010 11.496zm0 0"
        data-original="#bf8e75"
      ></path>
      <path
        fill="#bfd5de"
        d="M294.664 446.45h51.2v15.675h-51.2zm0 0"
        data-original="#bfd5de"
      ></path>
      <path
        fill="#2a2f4f"
        d="M249.125 81.762c35.574 2.543 64.14 31.281 65.953 67.46l.336 6.79h20.461l11.027 73.3 26.7-8.265-3.586-71.824c-1.895-38.004-33.325-67.786-71.364-67.649zm0 0"
        data-original="#2a2f4f"
      ></path>
      <path
        fill="#3d4159"
        d="M367.75 53.414c28.332 28.332 28.332 74.266 0 102.594-28.328 28.332-74.262 28.332-102.594 0zm0 0"
        data-original="#3d4159"
      ></path>
      <path
        fill="#3d4159"
        d="M265.16 156.008h-89.039l-11.023 73.304-26.696-8.265 3.578-71.828c1.895-37.996 33.325-67.785 71.368-67.645l128.586.485 17.003 30.601"
        data-original="#3d4159"
      ></path>
      <path
        fill="#2a2f4f"
        d="M262.867 81.762c-35.574 2.543-64.14 31.281-65.949 67.46l-.34 6.79h-20.46l-11.028 73.3-26.695-8.265 3.585-71.824c1.891-38.004 33.325-67.786 71.36-67.649zm0 0"
        data-original="#2a2f4f"
      ></path>
      <path
        fill="#f74f4f"
        d="M512 92.66c0 51.176-41.484 92.66-92.66 92.66-51.176 0-92.66-41.484-92.66-92.66C326.68 41.484 368.164 0 419.34 0 470.516 0 512 41.484 512 92.66zm0 0"
        data-original="#f74f4f"
      ></path>
      <path
        fill="#f2f0ec"
        d="M468.164 113.938l-27.539 27.539-70.102-70.098 27.54-27.543zm0 0"
        data-original="#f2f0ec"
      ></path>
      <path
        fill="#f2f0ec"
        d="M398.063 141.484l-27.54-27.539 70.102-70.101 27.54 27.539zm0 0"
        data-original="#f2f0ec"
      ></path>
    </svg>
  );
}

export default LostCustomer;
